export class KoEvents {
	public static actionComplete = new ko.subscribable<any>();

	public static saveCompleteEvent = "saveCompleteEvent";
	public static copyCompleteEvent = "copyCompleteEvent";
	public static deleteCompleteEvent = "deleteCompleteEvent";
	public static newCompleteEvent = "newCompleteEvent";
	public static undoCompleteEvent = "undoCompleteEvent";
	public static searchStartEvent = "searchStartEvent";
	public static searchEndEvent = "searchEndEvent";
	public static customCompleteEvent = "customCompleteEvent";

	public static saveComplete(newSelection?: any[]) {
		KoEvents.actionComplete.notifySubscribers(newSelection, KoEvents.saveCompleteEvent);
	}

	public static addSaveCompleteHandler(cb: (newSelection: any[]) => void, target: any) {
		KoEvents.actionComplete.subscribe(cb, target, KoEvents.saveCompleteEvent);
	}

	public static copyComplete(newSelection?: any[]) {
		KoEvents.actionComplete.notifySubscribers(newSelection, KoEvents.copyCompleteEvent);
	}

	public static addCopyCompleteHandler(cb: (newSelection: any[]) => void, target: any) {
		KoEvents.actionComplete.subscribe(cb, target, KoEvents.copyCompleteEvent);
	}

	public static deleteComplete() {
		KoEvents.actionComplete.notifySubscribers(null, KoEvents.deleteCompleteEvent);
	}

	public static addDeleteCompleteHandler(cb: () => void, target: any) {
		KoEvents.actionComplete.subscribe(cb, target, KoEvents.deleteCompleteEvent);
	}

	public static newComplete(newSelection?: any[]) {
		KoEvents.actionComplete.notifySubscribers(newSelection, KoEvents.newCompleteEvent);
	}

	public static addNewCompleteHandler(cb: (newSelection: any[]) => void, target: any) {
		KoEvents.actionComplete.subscribe(cb, target, KoEvents.newCompleteEvent);
	}

	public static undoComplete(newSelection?: any[]) {
		KoEvents.actionComplete.notifySubscribers(newSelection, KoEvents.undoCompleteEvent);
	}
	public static addUndoCompleteHandler(cb: (newSelection: any[]) => void, target: any) {
		KoEvents.actionComplete.subscribe(cb, target, KoEvents.undoCompleteEvent);
	}

	public static searchStart(options: any) {
		KoEvents.actionComplete.notifySubscribers(options, KoEvents.searchStartEvent);
	}

	public static addSearchStartHandler(cb: (options: any) => void, target: any) {
		KoEvents.actionComplete.subscribe(cb, target, KoEvents.searchStartEvent);
	}

	public static searchEnd(options?: any) {
		KoEvents.actionComplete.notifySubscribers(options, KoEvents.searchEndEvent);
	}

	public static addSearchEndHandler(cb: (options?: any) => void, target: any) {
		KoEvents.actionComplete.subscribe(cb, target, KoEvents.searchEndEvent);
	}

	public static customComplete(param?: any) {
		KoEvents.actionComplete.notifySubscribers(param, KoEvents.customCompleteEvent);
	}

	public static addCustomCompleteHandler(cb: (param: any) => void, target: any) {
		KoEvents.actionComplete.subscribe(cb, target, KoEvents.customCompleteEvent);
	}
}